module.exports = __webpack_public_path__ + "img/coupon.f4f60b5.png";